import type { ReactNode } from "react";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";
import { PersistenceStateUsingContext } from "@/shared/lib/persistence-state/persistence-state-info";

export function MonitorDetailSection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <PersistenceContextProvider>
      <section className="bg-background max-w-full min-w-0 overflow-x-auto rounded-md border p-4">
        <div className="mb-4 flex items-start justify-between gap-4">
          <div className="text-sm font-semibold">{title}</div>
          <PersistenceStateUsingContext className="shrink-0 text-xs" />
        </div>
        {children}
      </section>
    </PersistenceContextProvider>
  );
}
